module.exports = __webpack_public_path__ + "img/hacksaw.c57e266a.png";